
import {ChangeEvent} from "react";

export default function TextField(props: textFieldProps) {

    function changeInput (event: ChangeEvent<HTMLInputElement>){
        props.onChangeValue(event.target.value)
    }

    return (
        <>
            {props.displayName &&
                <label htmlFor={props.field}>{props.displayName}</label>
            }
            <input type={props.type} name={props.field} id={props.field} className="form-control" value={props.value} onChange={changeInput} />
        </>
    )
}

interface textFieldProps{
    field: string;
    displayName?: string;
    value: string;
    type: 'text' | 'password';
    onChangeValue(value: string): void;
}

TextField.defaultProps = {
    type: 'text',
    value: ''
}